import { useState } from 'react';

/**
 * One way to run a write against a run, for every surface that offers one.
 *
 * A retry or an abandon can be refused: the run already moved, the step is no longer failed, the
 * definition is gone. A refusal that vanishes leaves the operator believing the run changed when
 * it did not, which is the worse half of the two outcomes. So the rejection is caught and held
 * for the caller to show, and `busy` keeps a second click from landing while the first is in
 * flight.
 */
export const useWorkflowWrite = () => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const write = async (go: () => Promise<void>) => {
    setBusy(true);
    setError(null);
    try {
      await go();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'That did not reach the run');
    } finally {
      setBusy(false);
    }
  };

  return { busy, error, clearError: () => setError(null), write };
};
